import { FC } from 'react';
import { useOfficeAccessDevicesList } from './resources/useOfficeAccessDevicesList';
import AccessDevicesListTemplate from 'components/template/AccessDevicesListTemplate';
import OpenOfficeAccessDeviceModal from './resources/OpenOfficeAccessDeviceModal';

export const AccessDevicesListTab: FC = () => {
  const {
    accessDevicesList,
    columns,
    pageCurrent,
    pageSize,
    totalPages,
    openAccessDeviceModalOptions,
    searchValue,
    searchValueText,
    inputRef,
    onSearch,
    onUpdateSearchValue,
    onChangePage,
    onChangeAccessDevicesTable,
    loadingAccessDevices,
  } = useOfficeAccessDevicesList();

  const {
    onCloseAccessDeviceModal,
    onOpenAccessDevice,
    openAccessDeviceModalLiterals,
    openAccessModalVisible,
  } = openAccessDeviceModalOptions;

  return (
    <>
      <AccessDevicesListTemplate
        accessDevicesList={accessDevicesList}
        columns={columns}
        page={pageCurrent}
        size={pageSize}
        totalPages={totalPages}
        searchValue={searchValue}
        searchButtonText={searchValueText}
        inputRef={inputRef}
        onSearch={onSearch}
        onUpdateSearchValue={onUpdateSearchValue}
        onChangePage={onChangePage}
        onChangeAccessDevicesTable={onChangeAccessDevicesTable}
        loading={loadingAccessDevices}
      />
      <OpenOfficeAccessDeviceModal
        literals={openAccessDeviceModalLiterals}
        title={openAccessDeviceModalLiterals.title}
        onCancel={onCloseAccessDeviceModal}
        onOk={onOpenAccessDevice}
        open={openAccessModalVisible}
      />
    </>
  )
}

export default AccessDevicesListTab;